import { render } from "./RapeseedIcon.vue?vue&type=template&id=e13e248c"
import script from "./RapeseedIcon.vue?vue&type=script&lang=js"
export * from "./RapeseedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__